import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getWizardScreens } from './GenericWizardBlockThunk';

const initialState = {
    epiBlockData: {},
    page: '',
    wizard: {},
    screens: [],
    currentScreenId: '',
    displayScreen: {},
    phoneNumberForCallBack: '',
    isAlreadyHasCallBack: false
};

const genericWizardBlockSlice = createSlice({
  name: 'genericWizardBlock',
  initialState: initialState,

  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
        reducer: (state, action) => {
            state.epiBlockData = action.payload.epiBlockData;
            state.page = action.payload.page;
        },
        prepare: (action) => {
            let payload = {};
            const epiBlockDataObj = action.epiBlockData;
            const templateWizardType = getTemplateWizardName(epiBlockDataObj.templateWizard.value);
            let epiBlockData = {
                blockId: epiBlockDataObj.contentLink.id,
                wizardId: epiBlockDataObj.wizardID.value,
                isDisplayCallBack: epiBlockDataObj.isDisplayCallBack.value,
                subjectCode: epiBlockDataObj.subjectCode.value,
                templateWizard: templateWizardType,
                memoCode: epiBlockDataObj.memoCode.value,
                memoTextSuccess: epiBlockDataObj.memoTextSuccess.value,
                memoTextError: epiBlockDataObj.memoTextError.value,
                memoTextCallBack: epiBlockDataObj.memoTextCallBack.value,
                successPage: {
                    icon: epiBlockDataObj.successPageIcon.value?.url,
                    title: epiBlockDataObj.successPageTitle.value,
                    subTitle: epiBlockDataObj.successPageSubTitle.value,
                    buttonText: epiBlockDataObj.successPageButtonText.value,
                    buttonLink: epiBlockDataObj.successPageButtonLink.value,
                },
                errorPage: {
                    icon: epiBlockDataObj.errorPageIcon.value?.url,
                    title: epiBlockDataObj.errorPageTitle.value,
                    subTitle: epiBlockDataObj.errorPageSubTitle.value,
                    buttonText: epiBlockDataObj.errorPageButtonText.value,
                    buttonLink: epiBlockDataObj.errorPageButtonLink.value,
                }
            };

            payload.epiBlockData = epiBlockData;
            return { payload: payload };
        },
    },
    setWizardData: (state, action) => {
        state.wizard = action.payload.wizard;
        state.screens = action.payload.screens;
    },
    reportDWH: (state, action) => { },
    setPhoneNumberForCallBack: (state, action) => {
        state.phoneNumberForCallBack = action.payload;
    },
    setIsAlreadyHasCallBack: (state, action) => {
        state.isAlreadyHasCallBack = action.payload;
    },

    goToPage: (state, action) => {
        state.page = action.payload.page;
        state.currentScreenId = action.payload.screenId;
        if(state.screens?.length > 0 && action.payload.screenId){
            state.displayScreen = state.screens?.find(x => x.id == action.payload.screenId);
        }
        window.scrollTo(0, 0);
    },

  },
  extraReducers: {
    [getWizardScreens.fulfilled]: (state, action) => {
        state.wizard = action.payload.wizard;
        state.screens = action.payload.screens;
    },

  },
});

export const {
    resetBlock,
    initBlock,
    reportDWH,
    goToPage,
    setPhoneNumberForCallBack,
    setIsAlreadyHasCallBack
} = genericWizardBlockSlice.actions;

export default genericWizardBlockSlice.reducer;


function getTemplateWizardName(WizardType) {
  switch (WizardType) {
    case null:
    case 0:
      return 'CELLCOM';
    case 1:
      return 'GOLAN';
    case 2:
      return 'DINAMIKA';
    default:
      return 'CELLCOM';
  }
}
